<template>
  <div class="menubar-profile">

    <!-- <SidebarContact :contact-id="myUserId" class="menubar-profile-user" /> -->

    <ProfileMenu class="menubar-profile-user" />

    <NotificationMenu />

  </div>
</template>

<script>
// import SidebarContact from '@/layouts/Elements/SidebarContact'
import ProfileMenu from '@/layouts/Elements/ProfileMenu'
import NotificationMenu from '@/layouts/Elements/NotificationMenu'

// xTODO: name
// xTODO: correct image, fix image
// xTODO: Replace feather icons!!

// TODO: online status?

export default {
  data: () => ({}),
  computed: {
    myUserId() {
      return this.$models.user.defaultUserId;
    }
  },
  methods: {
  },
  components: {
    ProfileMenu,
    // SidebarContact,
    NotificationMenu,
  }
};
</script>
